import styled from 'styled-components';

interface NotificationStyleProps {
  fontSize: string;
  fontColor: string;
  cashSpace?: string;
}

const NotificationWrap = styled.div<NotificationStyleProps>`
  text-align: center;
  font-weight: 700;
  margin: 20px 0;
  font-size: ${(props) => props.fontSize};
  letter-spacing: ${(props) => !!props.cashSpace ? props.cashSpace : '-1.5px'};
  color: ${(props) => props.fontColor};
`;

const Notification = (props: { text: string; styles: NotificationStyleProps }) => {
  return (
    <NotificationWrap {...props.styles}>
      <div dangerouslySetInnerHTML={{ __html: props.text }}></div>
    </NotificationWrap>
  );
};

export default Notification;
